// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import React from 'react'
import { i18n } from '../../index'
import CheckQuestionForm from './CheckQuestionForm'
import css from './checkQuestion.css'

type CheckQuestion = {
  id?: string
  type?: string
  description?: string
}

type Props = {
  data?: CheckQuestion | null
  type: string
  stationId?: string
  isOpen: boolean
  createMutation: any
  updateMutation: any
  refetchQuery: any
  refetchVariables?: Record<string, any>
  onClose: (...args: Array<any>) => any
}

class CheckQuestionDialog extends React.Component<Props> {
  render() {
    const { data, type, stationId, isOpen, createMutation, updateMutation, refetchQuery, refetchVariables, onClose } =
      this.props
    return (
      <Dialog open={isOpen} onClose={onClose} aria-labelledby='check-question-dialog-title' className={css.dialog}>
        <DialogTitle id='check-question-dialog-title'>
          {data && data.id
            ? i18n.t('admin.checkQuestions.updateDialogTitle')
            : i18n.t('admin.checkQuestions.createDialogTitle')}
        </DialogTitle>
        <DialogContent>
          <CheckQuestionForm
            data={data}
            type={type}
            stationId={stationId}
            createMutation={createMutation}
            updateMutation={updateMutation}
            refetchQuery={refetchQuery}
            refetchVariables={refetchVariables}
            onSubmit={onClose}
            onCancel={onClose}
          />
        </DialogContent>
      </Dialog>
    )
  }
}

export default CheckQuestionDialog
